import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICustomFilter } from '../../pages/settings/filter-settings/custom-filters/custom-filters.interface';
import { IBaseResponse, IGetManyResponse } from '../../utilities/http-utilities.service';

@Injectable({ providedIn: 'root' })
export class CustomFilterService {
  constructor(private http: HttpClient) {}

  public getOne(id: number, options: Parameters<HttpClient['get']>[1]): Observable<IBaseResponse<ICustomFilter>> {
    return this.http.get<IBaseResponse<ICustomFilter>>(`custom-filters/${id}`, options);
  }

  public getMany<T extends ICustomFilter = ICustomFilter>(
    options: Parameters<HttpClient['get']>[1],
  ): Observable<IGetManyResponse<T>> {
    return this.http.get<IGetManyResponse<T>>('custom-filters', options);
  }

  public getInUseData(id: number): Observable<IBaseResponse<Record<string, string[]>>> {
    return this.http.get<IBaseResponse<Record<string, string[]>>>(`custom-filters/${id}/validate-usage`);
  }
}
